import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { ModulePasswordlessAccess } from './module-passwordless-access.model';

export class ModulePasswordlessAccessStateModel extends EntityStateModel<ModulePasswordlessAccess> {}
